// Footer.jsx
import React, { useState, useEffect } from 'react';
import './Footer.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import facebookIcon from '../../images/socials/facebook.png';
import twitterIcon from '../../images/socials/twitter.png';
import instagramIcon from '../../images/socials/instagram.png';
import emailIcon from '../../images/socials/email.png';
import omalogo from '../../images/Oma-New-Logo.png'
import { link_items } from "../../utils";
import CTA from '../CTA/CTA';

const Footer = () => {
  const [email, setEmail] = useState('');
  
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);



  // Footer links data
  const helpLinks = [
    // { id: 1, name: "Customer Support", url: "/support" },
    { id: 1, name: "Customer Support", url: "https://wa.link/af5kxz" },
    { id: 2, name: "Terms & Conditions", url: "/terms" },
    { id: 3, name: "Privacy Policy", url: "/privacy" }
  ];

  const socialLinks = [
    { id: 1, name: "Facebook", icon: facebookIcon, url: "https://web.facebook.com/omamediasupreme" },
    { id: 3, name: "Instagram", icon: instagramIcon, url: "https://www.instagram.com/oma.media.space/" },
    { id: 4, name: "Email", icon: emailIcon, url: "https://youtube.com" }
  ];


  return (
    <>
      <CTA />
      <footer className="footer">
        <div className="footer__container">
          <div className="footer__top">
            <div className="footer__brand" data-aos="fade-up">
              <div className="footer__logo">
                <img src={omalogo} alt="Oma Media Logo" />
              </div>
              <p className="footer__description className='text-1'">
              We don't just manage your social media—we engineer your digital breakthrough. Whether you're a small business, creator, or company looking to scale, we help you build a brand that SELLS and STICKS.
              </p>
              <div className="footer__social">
                {socialLinks.map(social => (
                  <a 
                    key={social.id} 
                    href={social.url} 
                    className="footer__social-link"
                    aria-label={social.name}
                  >
                    <img src={social.icon} alt={social.name} />
                  </a>
                ))}
              </div>
            </div>

            <div className="footer__links-container">
              <div className="footer__links" data-aos="fade-up" data-aos-delay="100">
                <h3 className="footer__links-title">COMPANY</h3>
                <ul className="footer__links-list">
                  {link_items.map((link, idx) => (
                    <li key={idx} className='text-1'>
                      <Link to={link.url} className="footer__link">{link.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="footer__links" data-aos="fade-up" data-aos-delay="200">
                <h3 className="footer__links-title">HELP</h3>
                <ul className="footer__links-list">
                  {helpLinks.map(link => (
                    <li key={link.id} className='text-1'>
                      <Link to={link.url} className="footer__link"> {link.name} </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="footer__divider"></div>

          <div className="footer__bottom">
            <p className="footer__copyright">
              © Copyright {new Date().getFullYear()}, All Rights Reserved by Oma Media
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;